import clsx from "clsx"

import { TruncatableText } from "@particles"

import { Hint, Icon } from "@atoms"

import styles from "./PopoverHeaderTitle.module.scss"
import type { PopoverHeaderTitleProps } from "./PopoverHeaderTitle.types"

export default function PopoverHeaderTitle(props: PopoverHeaderTitleProps) {
    const {
        title,
        className,
        titleLeftIcon,
        titleRightIcon,
        hint,
        caption,
        captionPlacement = "bottom",
        captionLeftIcon,
        captionRightIcon,
        avatar,
    } = props

    // The right slot holds an icon or a hint trigger, never both; the props type enforces it.
    const titleRightSlot = titleRightIcon ? <Icon icon={titleRightIcon} size={14} /> : hint ? <Hint {...hint} /> : null

    const captionRow = caption ? (
        <div className={styles.captionRow}>
            {captionLeftIcon && (
                <span className={styles.captionLeftIcon}>
                    <Icon icon={captionLeftIcon} size={14} />
                </span>
            )}
            <TruncatableText
                className={styles.captionText}
                text={caption}
                tooltipOnTruncate={true}
                tooltipPlacement="top"
            />
            {captionRightIcon && (
                <span className={styles.captionRightIcon}>
                    <Icon icon={captionRightIcon} size={14} />
                </span>
            )}
        </div>
    ) : null

    return (
        <div className={clsx(styles.base, className)}>
            {avatar && <div className={styles.avatarSlot}>{avatar}</div>}
            <div className={styles.textBlock}>
                {captionPlacement === "top" && captionRow}
                <div className={styles.titleRow}>
                    {titleLeftIcon && (
                        <span className={styles.titleLeftIcon}>
                            <Icon icon={titleLeftIcon} size={14} />
                        </span>
                    )}
                    <TruncatableText
                        className={styles.titleText}
                        text={title}
                        tooltipOnTruncate={true}
                        tooltipPlacement="top"
                    />
                    {titleRightSlot && <span className={styles.titleRightSlot}>{titleRightSlot}</span>}
                </div>
                {captionPlacement === "bottom" && captionRow}
            </div>
        </div>
    )
}
